import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/seo-services/google-searches.webp";

function Seogooglesearch() {
  return (
    <section
      className="seo_google_search p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Over 99,000 Searches On <span>Google</span> Every Second
            </h2>
            <p>
              Numbers like these, powered by statistics, help to explain how SEO
              influences the international traffic of users on SERP. We have
              this fact clear and help our clients by providing the necessary
              skill set and the best strategies.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={11}
            xxl={10}
            className="m-auto text-center"
          >
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="search_svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="189"
                    height="188"
                    fill="none"
                    viewBox="0 0 189 188"
                  >
                    <circle
                      cx="94.873"
                      cy="94"
                      r="80.545"
                      fill="#052943"
                    ></circle>
                    <mask id="path-2-inside-1_2327_5845" fill="#fff">
                      <path d="M22.686 107.524c-3.858.723-7.605-1.819-7.985-5.726a80.545 80.545 0 1140.71 62.42c-3.422-1.923-4.238-6.376-2.02-9.615 2.216-3.239 6.624-4.03 10.082-2.173a66.328 66.328 0 0086.953-94.665A66.331 66.331 0 0028.739 99.173c.306 3.913-2.195 7.628-6.053 8.351z"></path>
                    </mask>
                    <path
                      stroke="#F47A1F"
                      strokeWidth="28"
                      d="M22.686 107.524c-3.858.723-7.605-1.819-7.985-5.726a80.545 80.545 0 1140.71 62.42c-3.422-1.923-4.238-6.376-2.02-9.615 2.216-3.239 6.624-4.03 10.082-2.173a66.328 66.328 0 0086.953-94.665A66.331 66.331 0 0028.739 99.173c.306 3.913-2.195 7.628-6.053 8.351z"
                      mask="url(#path-2-inside-1_2327_5845)"
                    ></path>
                    <path
                      fill="#fff"
                      d="M72.348 85.357L60.3 114.253h-8.4l12.192-27.984H49.164v-7.008h23.184v6.096zm25.592 1.008H82.964v6.624c.64-.704 1.536-1.28 2.688-1.728 1.152-.448 2.4-.672 3.744-.672 2.4 0 4.384.544 5.952 1.632 1.6 1.088 2.768 2.496 3.504 4.224.736 1.728 1.104 3.6 1.104 5.616 0 3.744-1.056 6.72-3.168 8.928-2.112 2.176-5.088 3.264-8.928 3.264-2.56 0-4.784-.432-6.672-1.296-1.888-.896-3.344-2.128-4.368-3.696-1.024-1.568-1.584-3.376-1.68-5.424h8.016a4.433 4.433 0 001.392 2.496c.736.64 1.744.96 3.024.96 1.504 0 2.624-.48 3.36-1.44.736-.96 1.104-2.24 1.104-3.84 0-1.568-.384-2.768-1.152-3.6-.768-.832-1.888-1.248-3.36-1.248-1.088 0-1.984.272-2.688.816a3.585 3.585 0 00-1.392 2.064h-7.92v-20.88H97.94v7.2zm3.475 1.68c0-2.592.736-4.592 2.208-6 1.504-1.408 3.44-2.112 5.808-2.112s4.288.704 5.76 2.112c1.472 1.408 2.208 3.408 2.208 6s-.736 4.592-2.208 6c-1.472 1.408-3.392 2.112-5.76 2.112s-4.304-.704-5.808-2.112c-1.472-1.408-2.208-3.408-2.208-6zm32.592-7.584l-18.48 33.792h-7.92l18.48-33.792h7.92zm-24.624 4.272c-1.536 0-2.304 1.104-2.304 3.312 0 2.176.768 3.264 2.304 3.264.736 0 1.312-.272 1.728-.816.416-.544.624-1.36.624-2.448 0-2.208-.784-3.312-2.352-3.312zm14.88 21.936c0-2.592.736-4.592 2.208-6 1.472-1.408 3.392-2.112 5.76-2.112s4.288.704 5.76 2.112c1.472 1.408 2.208 3.408 2.208 6s-.736 4.592-2.208 6c-1.472 1.408-3.392 2.112-5.76 2.112s-4.288-.704-5.76-2.112c-1.472-1.408-2.208-3.408-2.208-6zm7.92-3.312c-.736 0-1.312.272-1.728.816-.384.544-.576 1.376-.576 2.496 0 2.176.768 3.264 2.304 3.264.736 0 1.312-.272 1.728-.816.416-.544.624-1.36.624-2.448 0-1.088-.208-1.904-.624-2.448-.416-.576-.992-.864-1.728-.864z"
                    ></path>
                  </svg>
                </div>
                <p style={{ color: "#fff" }}>
                  During web browsing, users don’t move beyond page one of
                  search results.
                </p>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="search_svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="189"
                    height="188"
                    fill="none"
                    viewBox="0 0 189 188"
                  >
                    <circle
                      cx="94.873"
                      cy="94"
                      r="80.545"
                      fill="#052943"
                    ></circle>
                    <mask id="path-2-inside-1_2327_5851" fill="#fff">
                      <path d="M22.686 107.524c-3.858.723-7.605-1.819-7.985-5.726a80.54 80.54 0 0136.167-75.263 80.542 80.542 0 0122.248-10.087c3.779-1.06 7.504 1.512 8.227 5.37.723 3.858-1.835 7.535-5.593 8.666a66.333 66.333 0 00-47.011 68.689c.306 3.913-2.195 7.628-6.053 8.351z"></path>
                    </mask>
                    <path
                      stroke="#F47A1F"
                      strokeWidth="28"
                      d="M22.686 107.524c-3.858.723-7.605-1.819-7.985-5.726a80.54 80.54 0 0136.167-75.263 80.542 80.542 0 0122.248-10.087c3.779-1.06 7.504 1.512 8.227 5.37.723 3.858-1.835 7.535-5.593 8.666a66.333 66.333 0 00-47.011 68.689c.306 3.913-2.195 7.628-6.053 8.351z"
                      mask="url(#path-2-inside-1_2327_5851)"
                    ></path>
                    <path
                      fill="#fff"
                      d="M49.116 86.845v-7.632h13.296v35.04h-8.544V86.845h-4.752zm25.343 17.136c.48 2.528 1.952 3.792 4.416 3.792 1.696 0 2.896-.752 3.6-2.256.704-1.504 1.056-3.952 1.056-7.344-.704.992-1.664 1.76-2.88 2.304-1.216.544-2.576.816-4.08.816-2.048 0-3.872-.416-5.472-1.248-1.6-.864-2.864-2.128-3.792-3.792-.896-1.696-1.344-3.744-1.344-6.144 0-2.368.48-4.432 1.44-6.192a10.255 10.255 0 014.176-4.08c1.824-.96 3.968-1.44 6.432-1.44 4.736 0 8.048 1.472 9.936 4.416 1.888 2.944 2.832 7.28 2.832 13.008 0 4.16-.384 7.6-1.152 10.32-.736 2.688-2 4.736-3.792 6.144-1.76 1.408-4.176 2.112-7.248 2.112-2.432 0-4.512-.48-6.24-1.44-1.696-.96-3.008-2.224-3.936-3.792-.896-1.568-1.408-3.296-1.536-5.184h7.584zm3.984-9.168c1.344 0 2.416-.4 3.216-1.2.8-.832 1.2-1.952 1.2-3.36 0-1.536-.416-2.72-1.248-3.552-.832-.832-1.952-1.248-3.36-1.248s-2.528.432-3.36 1.296c-.8.832-1.2 1.984-1.2 3.456 0 1.376.4 2.496 1.2 3.36.832.832 2.016 1.248 3.552 1.248zm30.971 19.44l-5.136-7.44-4.32 7.44h-8.88l8.832-13.68-9.072-13.104h9.216l5.136 7.392 4.32-7.392h8.88l-8.976 13.488 9.216 13.296h-9.216z"
                    ></path>
                  </svg>
                </div>
                <p style={{ color: "#fff" }}>
                  More clicks that go to the top organic result than the top
                  paid result.
                </p>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="search_svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="189"
                    height="188"
                    fill="none"
                    viewBox="0 0 189 188"
                  >
                    <circle
                      cx="94.873"
                      cy="94"
                      r="80.545"
                      fill="#052943"
                    ></circle>
                    <mask id="path-2-inside-1_2327_5857" fill="#fff">
                      <path d="M22.686 107.524c-3.858.723-7.605-1.819-7.985-5.726a80.545 80.545 0 1140.71 62.42c-3.422-1.923-4.238-6.376-2.02-9.615 2.216-3.239 6.624-4.03 10.082-2.173a66.328 66.328 0 0086.953-94.665A66.331 66.331 0 0028.739 99.173c.306 3.913-2.195 7.628-6.053 8.351z"></path>
                    </mask>
                    <path
                      stroke="#F47A1F"
                      strokeWidth="28"
                      d="M22.686 107.524c-3.858.723-7.605-1.819-7.985-5.726a80.545 80.545 0 1140.71 62.42c-3.422-1.923-4.238-6.376-2.02-9.615 2.216-3.239 6.624-4.03 10.082-2.173a66.328 66.328 0 0086.953-94.665A66.331 66.331 0 0028.739 99.173c.306 3.913-2.195 7.628-6.053 8.351z"
                      mask="url(#path-2-inside-1_2327_5857)"
                    ></path>
                    <path
                      fill="#fff"
                      d="M61.24 87.68c-.213-.987-.587-1.72-1.12-2.2-.533-.507-1.293-.76-2.28-.76-1.52 0-2.613.667-3.28 2-.667 1.307-1.013 3.387-1.04 6.24.587-.933 1.427-1.667 2.52-2.2 1.12-.533 2.347-.8 3.68-.8 2.613 0 4.707.827 6.28 2.48 1.6 1.653 2.4 3.96 2.4 6.92 0 1.947-.4 3.653-1.2 5.12-.773 1.467-1.92 2.613-3.44 3.44-1.493.827-3.267 1.24-5.32 1.24-4.107 0-6.96-1.28-8.56-3.84-1.6-2.587-2.4-6.293-2.4-11.12 0-5.067.84-8.827 2.52-11.28 1.707-2.48 4.427-3.72 8.16-3.72 2 0 3.68.4 5.04 1.2 1.387.773 2.427 1.8 3.12 3.08.72 1.28 1.147 2.68 1.28 4.2h-6.36zm-3.16 7.68c-1.147 0-2.107.347-2.88 1.04-.747.667-1.12 1.627-1.12 2.88 0 1.28.347 2.28 1.04 3 .72.72 1.733 1.08 3.04 1.08 1.173 0 2.093-.347 2.76-1.04.693-.72 1.04-1.693 1.04-2.92 0-1.253-.333-2.24-1-2.96-.667-.72-1.627-1.08-2.88-1.08zm14.989-2.04c-2.507-1.333-3.76-3.427-3.76-6.28 0-1.44.373-2.747 1.12-3.92.746-1.2 1.88-2.147 3.4-2.84 1.52-.72 3.386-1.08 5.6-1.08 2.213 0 4.066.36 5.56 1.08 1.52.693 2.653 1.64 3.4 2.84.746 1.173 1.12 2.48 1.12 3.92s-.347 2.693-1.04 3.76a7.08 7.08 0 01-2.72 2.52c1.44.693 2.546 1.653 3.32 2.88.773 1.2 1.16 2.613 1.16 4.24 0 1.893-.48 3.533-1.44 4.92-.96 1.36-2.267 2.4-3.92 3.12-1.627.72-3.44 1.08-5.44 1.08-2 0-3.827-.36-5.48-1.08-1.627-.72-2.92-1.76-3.88-3.12-.96-1.387-1.44-3.027-1.44-4.92 0-1.653.386-3.08 1.16-4.28.773-1.227 1.866-2.173 3.28-2.84zm9.8-5.24c0-1.093-.32-1.933-.96-2.52-.614-.613-1.44-.92-2.48-.92s-1.88.307-2.52.92c-.614.613-.92 1.467-.92 2.56 0 1.04.32 1.867.96 2.48.64.587 1.466.88 2.48.88 1.013 0 1.84-.307 2.48-.92.64-.613.96-1.44.96-2.48zm-3.44 8.2c-1.254 0-2.267.347-3.04 1.04-.774.667-1.16 1.6-1.16 2.8 0 1.12.373 2.04 1.12 2.76.773.72 1.8 1.08 3.08 1.08s2.28-.36 3-1.08c.746-.72 1.12-1.64 1.12-2.76 0-1.173-.387-2.107-1.16-2.8-.747-.693-1.734-1.04-2.96-1.04zm14.657 13.04c-1.2 0-2.186-.347-2.96-1.04-.746-.72-1.12-1.6-1.12-2.64 0-1.067.374-1.96 1.12-2.68.774-.72 1.76-1.08 2.96-1.08 1.174 0 2.134.36 2.88 1.08.774.72 1.16 1.613 1.16 2.68 0 1.04-.386 1.92-1.16 2.64-.746.693-1.706 1.04-2.88 1.04zm22.049-24.4L106.095 109h-7l10.16-23.32h-12.44v-5.84h19.32v5.08zm-1.793 2.24c0-2.16.613-3.827 1.84-5 1.253-1.173 2.866-1.76 4.84-1.76 1.973 0 3.573.587 4.8 1.76 1.226 1.173 1.84 2.84 1.84 5s-.614 3.827-1.84 5c-1.227 1.173-2.827 1.76-4.8 1.76-1.974 0-3.587-.587-4.84-1.76-1.227-1.173-1.84-2.84-1.84-5zm27.16-6.32l-15.4 28.16h-6.6l15.4-28.16h6.6zm-20.52 3.56c-1.28 0-1.92.92-1.92 2.76 0 1.813.64 2.72 1.92 2.72.613 0 1.093-.227 1.44-.68.346-.453.52-1.133.52-2.04 0-1.84-.654-2.76-1.96-2.76zm12.4 18.28c0-2.16.613-3.827 1.84-5 1.226-1.173 2.826-1.76 4.8-1.76 1.973 0 3.573.587 4.8 1.76 1.226 1.173 1.84 2.84 1.84 5s-.614 3.827-1.84 5c-1.227 1.173-2.827 1.76-4.8 1.76-1.974 0-3.574-.587-4.8-1.76-1.227-1.173-1.84-2.84-1.84-5zm6.6-2.76c-.614 0-1.094.227-1.44.68-.32.453-.48 1.147-.48 2.08 0 1.813.64 2.72 1.92 2.72.613 0 1.093-.227 1.44-.68.346-.453.52-1.133.52-2.04s-.174-1.587-.52-2.04c-.347-.48-.827-.72-1.44-.72z"
                    ></path>
                  </svg>
                </div>
                <p style={{ color: "#fff" }}>
                  Clicks are received by Google’s top three organic search
                  results from the overall results.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Seogooglesearch;
